/* @ngInject */

export default ($rootScope, dateTimeService, Address) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function HomeLoanVerificationApplicant(
    id,
    idContact,
    identified,
    verificationMethod,
    address,
    dateVerified
  ) {
    this.id = id;
    this.idContact = idContact;
    this.identified = identified;
    this.verificationMethod = verificationMethod;
    this.address = address;
    this.dateVerified = dateVerified;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  HomeLoanVerificationApplicant.Blank = function (idContact) {
    return HomeLoanVerificationApplicant.Build({
      id: _.uuid(),
      idContact,
      identified: '',
      verificationMethod: '',
      address: Address.blank(),
      dateVerified: 0
    });
  };
  HomeLoanVerificationApplicant.Build = function (data) {
    return new HomeLoanVerificationApplicant(
      data.id ? data.id : _.uuid(),
      data.idContact ? data.idContact : '',
      data.identified ? data.identified : '',
      data.verificationMethod ? data.verificationMethod : '',
      _.isEmpty(data.address) ? Address.blank() : Address.build(data.address),
      data.dateVerified ? data.dateVerified : 0
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  HomeLoanVerificationApplicant.prototype.getAddress = function () {
    return Address.getAddress(this?.address);
  };
  HomeLoanVerificationApplicant.prototype.getSetDateVerified = function (date) {
    if (arguments.length) {
      if (arguments[0] !== null) {
        if (!this.dateVerified) {
          this.dateVerifiedObject = '';
        }
        const dateVerifiedObject = dateTimeService.setDate(
          date,
          $rootScope.CurrentTimeZone(),
          true
        );
        this.dateVerifiedObject = date;
        this.dateVerified = moment.utc(dateVerifiedObject).startOf('day').format('X');
      } else {
        this.dateVerifiedObject = date;
        this.dateVerified = 0;
      }
    }
    if (!this.dateVerifiedObject) {
      if (this.dateVerified) {
        const dateVerifiedObject = dateTimeService.setDate(
          this.dateVerified,
          $rootScope.CurrentTimeZone(),
          false
        );
        this.dateVerifiedObject = dateVerifiedObject;
      } else {
        this.dateVerifiedObject = '';
      }
    }
    return this.dateVerifiedObject;
  };
  HomeLoanVerificationApplicant.prototype.deleteDateObject = function () {
    delete this.dateVerifiedObject;
  };

  return HomeLoanVerificationApplicant;
};
